import { render, staticRenderFns } from "./group-criteria-list.vue?vue&type=template&id=228c4858&scoped=true"
import script from "./group-criteria-list.vue?vue&type=script&lang=js"
export * from "./group-criteria-list.vue?vue&type=script&lang=js"
import style0 from "./group-criteria-list.vue?vue&type=style&index=0&id=228c4858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228c4858",
  null
  
)

export default component.exports